import Footer from './Footer'

const Components = {
  Footer
}

export const registerComponents = (app) => {
  Object.keys(Components).forEach(key => {
    app.component(key, Components[key])
  })
}